function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP title
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { dateOfTravel } from '../../actions/index';
import DateInput from '../date-input/DateInput';
import Info from '../info/Info';
import moment from 'moment';
import './DateOfTravel.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class DateOfTravel extends React.Component {
  render() {
    const {
      dateOfTravel,
      setDateOfTravel
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(DateInput, {
        handleChange: setDateOfTravel,
        label: "Intended travel date",
        maxFuture: moment().add(5, 'years'),
        name: "dateOfTravel",
        onBlur: setDateOfTravel,
        range: "future",
        section: "personal-details",
        values: {
          dateOfTravel
        }
      }), /*#__PURE__*/_jsx(Info, {
        info: "If you are already overseas please select a valid future date and we will prioritise dispatch of your IDP to your selected overseas address."
      })]
    });
  }
}
_defineProperty(DateOfTravel, "defaultProps", {
  dateOfTravel: {
    value: ''
  }
});
const mapStateToProps = ({
  dateOfTravel
}) => {
  return {
    dateOfTravel
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setDateOfTravel: value => {
      dispatch(dateOfTravel(value));
    }
  };
};
const VisibleDateOfTravel = connect(mapStateToProps, mapDispatchToProps)(DateOfTravel);
export default VisibleDateOfTravel;